const cancel = 'Annuler'
const save = 'Sauvegarder'

export default {

  global: {
    generalError: 'Oups ! La requête n\'a pas pu être traitée. Veuillez actualiser la page.',
    signature: 'Cordialement,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Ajoutez un CV ou d\'autres fichiers joints',
      placeholderWithDescription: 'Ajouter les pièces jointes demandées',
      remove: 'Supprimer',
      allowedFileTypes: 'Types de fichiers autorisés',
      errors: {
        size: 'Le fichier est trop lourd, la taille de fichier maximale est de 5 Mo.',
        empty: 'Aucune donnée dans le fichier',
        invalidType: fileType => `Désolé, les fichiers ${fileType} ne sont pas autorisés pour des raisons de sécurité`,
        typeNotWhitelisted: 'Nous sommes désolés, ce type de fichier n’est pas autorisé.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Politique de confidentialité',
      termsLinkText: 'Conditions générales',
      privacyPolicyText: `Nous accordons de l'importance au respect de votre vie privée. Veuillez lire notre `,
      termsText1: 'Veuillez lire et accepter les ',
      termsText2: 'avant de nous fournir des données à caractère personnel.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Si vous ne souhaitez pas que nous traitions vos données personnelles, vous pouvez demander à les faire supprimer en contactant ${mail}.`,
      // eslint-disable-next-line no-irregular-whitespace
      customSupportPrivacyInfo: link => `Si vous ne souhaitez pas que vos données personnelles soient traitées, vous pouvez solliciter leur effacement en écrivant à : ${link}.`,
    },

    buttons: {
      close: 'Fermer',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Supprimer la prise',
      confirm: 'Réessayer',
    },

    confirmButton: {
      wait: count => `Patienter ${count}`,
      confirm: 'Confirmer',
    },

    controlStatus: {
      text: {
        empty: 'Remplir',
        valid: () => 'Prêt',
      },
      textarea: {
        empty: 'Remplir',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Définir',
        valid: () => 'Prêt',
      },
      file: {
        empty: 'Sélectionner',
        valid: () => 'Modifier',
      },
      list: {
        empty: 'Ajouter',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Rechercher',
        valid: () => 'Prêt',
      },
    },

    cookieConsentModal: {
      title: 'Notre site utilise des cookies',
      body: 'En acceptant tous les cookies, vous consentez à ce que des cookies soient déposés sur votre appareil pour améliorer la navigation sur le site, analyser l’utilisation du site et contribuer à nos efforts de marketing.',
      learnMoreLinkText: 'En savoir plus sur notre utilisation des cookies',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Gérer les cookies',
      acceptAll: 'Accepter tous les cookies',
      manageTitle: 'Gérer les préférences de consentement',
      necessaryCookiesTitle: 'Cookies techniques',
      necessaryCookiesBody:
        'Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés dans nos systèmes.',
      performanceCookiesTitle: 'Cookies de performance',
      performanceCookiesBody:
        'Ces cookies nous permettent de comptabiliser le nombre de visites et les sources de trafic, ce qui nous sert à mesurer et à améliorer les performances de notre site.',
      confirmChoices: 'Confirmer mes choix',
      marketingCookiesTitle: 'Cookies de marketing',
      marketingCookiesBody:
        'Ces cookies nous permettent de personnaliser la publicité et d’en mesurer l’efficacité.',
      functionalCookiesTitle: 'Cookies techniques',
      functionalCookiesBody:
        'Ces cookies servent à améliorer la fonctionnalité du site. Sans ces cookies, certaines fonctionnalités peuvent ne pas être disponibles. Les cookies techniques incluent, par exemple, les services de tchat et les préférences utilisateur.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Supprimer',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Interdit',
      content: 'Notre serveur a poliment (mais fermement) refusé d\'accéder à une requête de votre navigateur. Veuillez noter que Recright ne peut être utilisé que sur un seul appareil/navigateur (à la fois).',
      link: 'Première page',
    },

    error404: {
      heading: 'Donnée introuvable',
      content: 'Nous avons bien cherché, mais il n\'y a aucune page web à l\'adresse demandée. Il se peut que le lien ait expiré ou que l\'adresse saisie soit incorrecte.',
      link: 'Première page',
    },

    error410: {
      heading: 'Plus disponible',
      content: 'Le poste ne s\'affiche pas, car il n\'est plus disponible ou ne reçoit plus de candidature.',
      link: 'Première page',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Initialisation...',
      connection_error_hint: 'La connexion au réseau n\'a pas pu être établie.\nEssayez d\'actualiser la page.',
      permission_hint: 'Vous devez autoriser ce site à utiliser votre caméra et micro.',
      searching_camera_hint: 'Recherche d\'une caméra en cours...',
      camera_reserved_hint: 'Votre caméra est utilisée par une autre application ou page web.\nVeuillez fermer cette application et actualiser la page.',
      camera_reserved_hint_chrome_extra: '\n\nCher utilisateur de Chrome, vous devez autoriser Recright à utiliser votre caméra dans la boîte de dialogue située sous la barre d\'adresse.',
      no_camera_hint: 'Caméra introuvable.',
      no_mic_hint: 'Micro introuvable.',
      uploading_text: 'Importation en cours...',
      rtmpt_in_use: 'Cette étape ne serait pas nécessaire si votre administrateur\nde réseau autorisait RTMP. Contactez-nous pour en savoir plus.',
      preview_text: 'La caméra est en mode prévisualisation',
      close_text: 'Fermer la caméra',
      remove_text: 'Supprimer la prise',
      // eslint-disable-next-line no-irregular-whitespace
      noflash_errortext_install: link => `Il semble qu'Adobe Flash Player ne soit pas installé. Un plug-in Flash doit être installé pour enregistrer des vidéos. Télécharger Flash ici : ${link}`,
      // eslint-disable-next-line no-irregular-whitespace
      noflash_errortext_enable: link => `Si Flash est déjà installé, mais ce message s'affiche quand même, cliquez ici : ${link}`,
      noflash_errortext_differentbrowser: 'Sinon, vous pouvez essayer avec un navigateur qui prend en charge les enregistrements HTML5. Nous suggérons Chrome ou Firefox.',
    },

    footer: {
      terms: 'Conditions',
      license: 'General Terms of Service',
      privacyPolicy: 'Politique de confidentialité',
      customSupport: link => `Veuillez contacter ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Comment noteriez-vous votre expérience d\'entrevue ?',
      howWouldYouRateJobAd: 'Comment évalueriez-vous votre expérience d\'utilisation de l\'application ?',
      yourResponseIsAnonymous: 'Votre réponse restera anonyme.',
      thankYouFeedback: 'Merci pour votre retour !',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Nous sommes désolés, ce type de fichier n’est pas autorisé.',
      isRequired: 'Ce champ est obligatoire.',
      isEmail: value => `${value} n'est pas une adresse e-mail valide.`,
      isDate: value => `${value} n'est pas une date valide.`,
      invalidUrl: 'URL non valide.',
      singleHireEndError: 'L\'inscription pour une seule annonce expire dans un délai de 60 jours.',
      isNotTooOldForLive: 'La date est antérieure à la date d\'aujourd\'hui.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Nom',
      city: 'Ville',
      email: 'Courriel',
      phone: 'Numéro de téléphone',
      applyForPosition: 'Postuler à l\'offre',
      back: 'Retour',
      continue: 'Continuer',
      submit: 'Envoyer',
      saveForLater: 'Reprendre ultérieurement',
      namePlaceholder: 'Saisissez votre nom',
      emailPlaceholder: 'Saisissez votre adresse email',
      phonePlaceholder: 'Saisissez votre numéro de téléphone',
      cityPlaceholder: 'Saisissez votre ville de résidence actuelle',
      links: 'Ajoutez des liens, par exemple votre profil LinkedIn',
      legendBasicInfo: 'Informations de base',
      legendLinks: 'Liens',
      legendAttachments: 'Pièces jointes',
      legendAdditionalFields: 'Informations supplémentaires',
      coverLetter: 'Lettre de motivation',
      attachments: 'Pièces jointes',
      introduction: 'Présentez-vous brièvement ici',
      thankYou: 'Merci.',
      luck: 'Bonne chance !',
      close: 'Fermer',
      required: 'Les champs comportant un astérisque * sont obligatoires.',
    },

    jobAdContainer: {
      endTime: date => (date ? `clôture le ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Postuler à l\'offre',
    },

    jobAdQuickInterview: {
      back: 'Retour',
      submit: 'Envoyer',
      saveForLater: 'Reprendre ultérieurement',
      title: 'Entretien vidéo rapide',
      description: 'Pour vous connaître plus rapidement, nous vous invitons à répondre brièvement à notre question d\'entretien rapide. Mettez en avant votre personnalité et donnez vie à votre candidature.',
      requiredNote: 'Ceci n\'est qu\'une étape du processus de candidature. Le recruteur ne recevra votre candidature qu\'une fois votre réponse enregistrée.',
      reminderNote: 'Vous pouvez enregistrer votre réponse dès maintenant ou ultérieurement en recevant un rappel par e-mail.',
    },

    jobAdRow: {
      responses: 'Applications',
      status: {
        open: 'Vacant',
        filled: 'Pourvu',
        cancelled: 'Annulé',
        done: 'Terminé',
        close: 'Fermer',
        draft: 'Fermé (brouillon)',
        hidden: 'Caché',
      },
    },

    interviewRow: {
      responses: 'Candidats',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Afficher le profil LinkedIn',
    },

    linkedInButton: {
      error: 'Erreur lors de la récupération du profil. Veuillez réessayer.',
      buttonText: 'Postuler avec LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Vous pouvez utiliser votre profil LinkedIn pour pré-remplir le formulaire de candidature',
      linkedInOr: 'Ou',
      error: 'Erreur lors de la récupération du profil. Veuillez réessayer.',
    },

    linkListInput: {
      addField: 'Ajouter',
      removeField: 'Supprimer',
      invalidUrl: 'URL non valide.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Chargement en cours...',
      saving: 'Sauvegarde en cours...',
      sending: 'Envoi en cours...',
    },

    modalApplicationForm: {
      applyForPosition: 'Postuler à l\'offre',
      continue: 'Continuer',
      name: 'Saisissez votre nom',
      email: 'Saisissez votre adresse email',
      phoneNumber: 'Saisissez votre numéro de téléphone',
      links: 'Vous pouvez ajouter des liens',
      legendLinks: 'Liens',
      legendAttachments: 'Pièces jointes',
      coverLetter: 'Lettre de motivation',
      attachments: 'Pièces jointes',
      introduction: 'Présentez-vous ici',
      thankYou: 'Merci.',
      luck: 'Bonne chance !',
      close: 'Fermer',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Lien public à partager',
      info: 'Voici l\'adresse publique de l\'offre d\'emploi à partager.\nLes personnes intéressées par le poste peuvent voir l\'offre \net postuler si elles le souhaitent.\nVous recevrez une notification lorsque des candidatures sont envoyées.\n\nVoici un lien public de l\'offre d\'emploi :',
    },

    modalVideoAdd: {
      title: 'Ajouter une nouvelle vidéo',
      chooseTitle: 'Ajouter une nouvelle vidéo',
      titlePlaceholder: 'Saisir le titre de la vidéo ici',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Importer une nouvelle vidéo',
      info: 'La taille de la vidéo ne doit pas dépasser 500 Mo. Nous recommandons de compresser les vidéos avant de les importer pour réduire le temps d\'importation et de conversion.',
    },

    modalCandidateInfo: [
      {
        headline: 'Enregistrez votre réponse vidéo ',
        content: 'autant de fois que vous le souhaitez. Les vidéos sont immédiatement sauvegardées après l\'enregistrement et vous pouvez reprendre l\'entretien vidéo en cliquant sur le lien reçu par e-mail.',
        mobileContent: 'autant de fois que vous le souhaitez. Ajouter la vidéo à l\'entretien. La vidéo sera importée et sauvegardée dans l\'entretien. Vous pouvez reprendre l\'entretien vidéo en cliquant sur le lien reçu par e-mail. <br><br><strong>Si votre écran vidéo reste noir et que vous utilisez un appareil mobile Apple, vous trouverez des instructions pour résoudre ce problème <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">ici</a>.</strong>',
      },
      {
        headline: 'Après l\'enregistrement, ',
        content: 'assurez-vous que la vidéo se lit correctement et que votre voix est suffisamment audible. Lorsque vous appuyez sur le bouton «Envoyer», votre réponse est verrouillée et n\'est plus modifiable.',
      },
      {
        headline: 'Lorsque vous avez terminé l\'entretien, ',
        content: 'appuyez sur le bouton «Envoyer les réponses et terminer l\'entretien». Après cela, vous ne pourrez plus reprendre l\'entretien vidéo. Si vous souhaitez fermer cette page et reprendre l\'entretien ultérieurement, cliquez sur le bouton «Reprendre ultérieurement».',
      },
      {
        headline: 'Si vous avez besoin d\'aide ',
        content: mailto => `pour répondre à l'entretien vidéo, cliquez sur le bouton «Aide» en bas à droite de la page ou envoyez-nous un e-mail à ${mailto}.`,
        customContent: link => `Veuillez contacter ${link}`,
      },
    ],

    navigationBar: {
      back: 'Retour',
      dashboard: 'Tableau de bord',
      frontpage: 'Première page',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Numéro de téléphone au format ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Note moyenne',
      reset: 'réinitialiser',
    },

    share: {
      share: 'Partager avec',
      copy: 'Copier le lien',
    },

    sort: {
      sort: 'Trier',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Sélectionné',
      change: 'Modifier',
    },

    video: {
      videoNotFound: 'La vidéo est en cours de traitement ou est introuvable',
      retry: 'Réessayer',
      originalLanguageLabel: 'Original',
      englishLanguageLabel: 'Anglais',
    },

    videoUpload: {
      // eslint-disable-next-line no-irregular-whitespace
      uploadPlaceholder: isMobile => (isMobile ? 'Importer ou enregistrer une nouvelle vidéo' : 'Sélectionner le fichier'),
      videoPlaceholder: 'Enregistrer votre réponse',
      uploadPlaceholderCandidate: 'Importer une vidéo',
      submit: 'Envoyer la réponse',
      notAnswered: 'Vous n\'avez pas encore répondu',
      remove: 'Supprimer la prise',
      converting: 'Vidéo en cours de conversion. Veuillez patienter...',
      uploading: 'Vidéo en cours d\'importation. Veuillez patienter...',
      error: {
        invalid: 'Le fichier sélectionné est trop lourd. Veuillez sélectionner un autre fichier.',
        upload: 'Désolé, l\'importation de la vidéo a échoué. Veuillez réessayer.',
        transcode: 'Le fichier vidéo sélectionné est corrompu ou non valide, veuillez réessayer.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Voir plus',
      showLessButtonText: 'Voir moins',
      infoText1:
        'Maintenez l’onglet actif au premier plan pendant l’enregistrement. Vous ne devez pas utiliser d’autres applications pendant l’enregistrement.',
      infoText2:
        'Les arrière-plans vidéo fonctionnent mieux sur les navigateurs les plus récents et avec un dispositif relativement neuf et puissant.',
      infoText3:
        'Assurez-vous que d’autres applications n’utilisent pas votre microphone ou votre caméra.',
    },

    videoResponse: {
      videoPlaceholder: 'Enregistrer votre réponse',
      uploadPlaceholder: 'Importer une vidéo',
      submit: 'Envoyer la réponse',
      notAnswered: 'Vous n\'avez pas encore répondu',
      required: 'Cette question nécessite une réponse',
      startInterview: 'Commencer l\'entretien',
    },

    webcam: {
      useVideoBgButtonText: 'Utiliser l’arrière-plan vidéo',
      removeVideoBgButtonText: 'Retirer l’arrière-plan vidéo',
      starting: 'Démarrage en cours...',
      close: 'Fermer la caméra',
      remove: 'Supprimer la prise',
      record: 'Enregistrer',
      stop: 'Arrêter',
      retake: 'Nouvelle prise',
      submit: 'Envoyer la réponse',
      converting: 'Vidéo en cours de conversion. Veuillez patienter...',
      uploading: 'Vidéo en cours d\'importation. Veuillez patienter...',
      downloading: 'Vidéo en cours de téléchargement. Veuillez patienter...',
      processing: 'En cours de traitement...',
      uploadInProgress: 'Vidéo toujours en cours de transfert, ne fermez pas le navigateur et ne changez pas de page.',
      uploaded: 'Vidéo transférée.',
      error: {
        DevicesNotFoundError: 'Impossible d\'utiliser la caméra ou le micro. Veuillez vérifier si elle/s\'il est activé(e).',
        NotFoundError: 'Impossible d\'utiliser la caméra ou le micro. Veuillez vérifier si elle/s\'il est activé(e).',
        NotAllowedError: 'Vous n\'avez pas autorisé l\'utilisation de la caméra ou du micro.',
        PermissionDismissedError: 'Vous avez fermé la boîte de dialogue relative à l\'autorisation. Veuillez autoriser l\'utilisation de la caméra et du micro.',
        PermissionDeniedError: 'Vous avez refusé l\'accès de la caméra ou du micro.',
        NotReadableError: 'Impossible de lire le flux de la caméra ou du micro. Problème matériel possible.',
        SecurityError: 'Impossible d\'utiliser la caméra ou le micro en raison d\'une erreur de sécurité',
        stream: 'Une erreur s\'est produite. Veuillez redémarrer votre navigateur. Si le problème persiste, veuillez essayer avec un autre navigateur.',
        download: 'Le téléchargement de vidéo a échoué. Réessayer ?',
        upload: 'L\'importation de vidéo a échoué. Réessayer ?',
        emptyBlob: 'La mémoire de votre navigateur ou de votre appareil est pleine et ne peut pas créer l\'enregistrement. Veuillez actualiser la page. Si le problème n\'est pas résolu, redémarrez le navigateur.  Si le problème persiste, veuillez essayer avec un autre navigateur.',
        alternativeRecorder: 'Vous pouvez également téléverser un fichier en cliquant dessus.',
        reconnecting: 'La connexion a été interrompue. Tentative de reconnexion.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Bonjour ! Nous souhaitons vous inviter à un entretien vidéo ${title} ! Cette invitation vous a également été envoyée par courrier électronique. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
